<template lang="pug">
  .pdp-bottom
    LazyComponent
      template(#default="{ shown }")
        FixedWidthContainer(v-if="shown")
          .xs-12.xs-mt-400m.xs-mb-200m.xs-pb-300m.b-line
            ExpertiseIncluded

    LazyComponent
      template(#default="{ shown }")
        lockupBanner(v-if="shown" :cms="cmsSettings.moneyBackGuarantee")

    LazyComponent
      template(#default="{ shown }")
        FixedWidthContainer(v-if="shown && remainingXsellItemsAvailable.length > 0")
          .xs-12.mt-200m
            h3.text-center
              span.bold.upper.xs-f-small.lg-f-large.max-at-tweak Recommended
              br
              span.text-color-2.xs-f-medium.lg-f-xmedium.max-at-tweak  with {{ product.name }}
            PdpXsellCarousel(:items="remainingXsellItemsAvailable")

    .row
      DashHudsonScript
        template(#title="")
          h3.bold.upper.xs-f-small.md-f-small.lg-f-large.max-at-tweak.text-center Real clients, really gorgeous results

    Reviews(:product-id="product.id" :product-url-key="product.url_key")

</template>

<script>
  import { mapState } from "vuex";
  import { defineAsyncComponent } from "vue";
  import LazyComponent from '@components/LazyComponent';
  import FixedWidthContainer from '@components/FixedWidthContainer';
  import lockupBanner from '@components/banners/lockupBanner';
  import ExpertiseIncluded from '@components/ExpertiseIncluded';
  import Reviews from '@components/PDP/Reviews';
  import DashHudsonScript from "@components/PDP/DashHudsonScript.vue";

  export default {
    name: "PdpBottom",

    components: {
      DashHudsonScript,
      LazyComponent,
      FixedWidthContainer,
      lockupBanner,
      ExpertiseIncluded,
      Reviews,
      PdpXsellCarousel: defineAsyncComponent(() => import('@components/PDP/PdpXsellCarousel/PdpXsellCarousel')),
    },

    computed: {
      ...mapState('pdp', ['product']),
      ...mapState('cms', ['cmsSettings']),
      ...mapState('xsell', ['productXsellItems']),
      ...mapState('cart', ['cart']),

      remainingXsellItemsAvailable() {
        return this.productXsellItems.filter(product => !this.cart.items.find(item => item.id === product.id));
      },
    },
  };
</script>

<style scoped lang="stylus">
</style>
